import * as React from "react";
import { Avatar } from "primereact/avatar";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";

import MenuIcon from "@mui/icons-material/Menu";
import { useState, useRef } from "react";
// import { Test } from "./pages/test/test";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
// import { Test } from "./pages/test/test";
import { Logout } from "./pages/logout/logoutPage/logout";
import Typography from "@mui/material/Typography";
import Logo from "./assets/logo.png";
import Navbar from "./component/Navbar";
import NavbarGauche from "./component/NavbarGauche";
import "./App.css";

import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Login } from "./pages/login/loginPage/login";
import { Stockage } from "./pages/stockage/stockage";
import { StockageRetard } from "./pages/stockageRetard/stockageRetard";
import { Client } from "./pages/client/ClientPage/client";
import { Reglement } from "./pages/reglement/reglementPage/Reglement";
import { Users } from "./pages/users/usersPage/users";
import { Contrat } from "./pages/contrat/contratPage/contrat";

import Tasklist from "./pages/tasklist/tasklist";
import FicheListe from "./pages/fiche/fiche";
import FicheDemandeListe from "./pages/ficheDemande/ficheDem";

import { Dash } from "./pages/dashboard/dashboardPage/dash";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LocationStockage } from "./pages/location/locationPage/locationStockage";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect } from "react";
import { Facture } from "./pages/facture/facturePage/facture";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./styles/NavbarGauche.css";
import { Modal } from "@mui/material";
// import { Menu } from "primereact/menu";
import ReactDOM from "react-dom";

import LeadsList from "./pages/leads/leads";
import HistoriqueMailSuivi from "./pages/leads/historiqueMailSuivi";

import { OverlayPanel } from "primereact/overlaypanel";

import "primeflex/primeflex.css";
import { PrimeReactProvider } from "primereact/api";

const drawerWidth = 240;

function App(props) {
  const isMobilePortrait = useMediaQuery("(max-width:1400px) ");

  const [nomPageActive, setNomPageActive] = useState("Leads");
  const locationGauche = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const op = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  let items = [
    {
      label: "Déconnexion",
      icon: "pi pi-power-off",
      command: () => {
        setdeconnect(true);
      },
    },
  ];
  if (localStorage.getItem("us") === "admin") {
    items.unshift({
      label: "Utilisateurs",
      icon: "pi pi-users",
      command: () => {
        navigate("/users");
      },
    });
  }

  const [deconnectHovered, setDeconnectHovered] = useState(false);

  const [deconnect, setdeconnect] = useState(false);

  const [isConfirmingLogout, setIsConfirmingLogout] = useState(false);
  const logoutTimeoutRef = useRef(null);

  const toggleLogoutMode = (e) => {
    e.stopPropagation();
    if (!isConfirmingLogout) {
      setIsConfirmingLogout(true);
      logoutTimeoutRef.current = setTimeout(() => {
        setIsConfirmingLogout(false);
      }, 3000);
    }
  };

  useEffect(() => {
    return () => {
      if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
    };
  }, []);

  const handleLogout = () => {
    setdeconnect(true);
  };

  // Menu mobile (Drawer)
  const drawerMobile = (
    <div className="app-drawer">
      <div className="app-drawer__logo-wrap">
        <img src={Logo} alt="Logo" className="app-drawer__logo" />
      </div>

      <div className="app-drawer__nav">
        <Link
          to="/LeadsList"
          onClick={handleDrawerToggle}
          className={`app-drawer__link ${
            locationGauche.pathname === "/LeadsList" ? "active" : ""
          }`}
        >
          <i className="pi pi-users"></i>
          <span>Leads</span>
        </Link>

        <a
          href="https://drive.google.com/drive/folders/1taQ4Iif3n_H0rYhqlBB6fH-WVfzV0RPt?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          className="app-drawer__link"
        >
          <i className="pi pi-file"></i>
          <span>Plaquettes</span>
        </a>
      </div>

      <div className="app-drawer__footer">
        <div className="app-drawer__profile">
          <Avatar
            label={localStorage.getItem("us")?.charAt(0).toUpperCase()}
            shape="circle"
            style={{ backgroundColor: "#f1bd40", color: "#000", flexShrink: 0 }}
          />
          <div className="app-drawer__profile-info">
            <div className="app-drawer__profile-name">
              {localStorage.getItem("us") || "Admin"}
            </div>
            <div className="app-drawer__profile-role">Gestionnaire</div>
          </div>
          <i
            className="pi pi-sign-out app-drawer__logout-icon"
            onClick={() => setdeconnect(true)}
          ></i>
        </div>
      </div>
    </div>
  );

  // Barre de navigation horizontale fixe en haut
  const drawer = (
    <header className="app-header">
      <div className="app-header__inner">
        {/* Gauche : hamburger (mobile) + logo + nom */}
        <div className="app-header__left">
          <button
            onClick={handleDrawerToggle}
            className="app-header__hamburger"
            aria-label="Ouvrir le menu"
          >
            <MenuIcon />
          </button>
          <img src={Logo} alt="Logo" className="app-header__logo" />
        </div>

        {/* Centre : navigation (desktop uniquement) */}
        <nav className="app-header__nav">
          <Link
            to="/LeadsList"
            className={`app-header__nav-link ${
              locationGauche.pathname === "/LeadsList" ? "active" : ""
            }`}
          >
            <i className="pi pi-users"></i>
            <span>Leads</span>
          </Link>

          <a
            href="https://drive.google.com/drive/folders/1taQ4Iif3n_H0rYhqlBB6fH-WVfzV0RPt?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className="app-header__nav-link"
          >
            <i className="pi pi-file"></i>
            <span>Plaquettes</span>
          </a>
        </nav>

        {/* Droite : profil / déconnexion */}
        <div
          onClick={toggleLogoutMode}
          className={`app-header__profile ${isConfirmingLogout ? "confirming" : ""}`}
        >
          {!isConfirmingLogout ? (
            <>
              <Avatar
                label={localStorage.getItem("us")?.charAt(0).toUpperCase()}
                shape="circle"
                className="app-header__avatar"
                style={{ backgroundColor: "#f1bd40", color: "#000" }}
              />
              <div className="app-header__profile-info">
                <div className="app-header__profile-name">
                  {localStorage.getItem("us") || "Admin"}
                </div>
                <div className="app-header__profile-role">Gestionnaire</div>
              </div>
              <i className="pi pi-sign-out app-header__logout-icon"></i>
            </>
          ) : (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleLogout();
              }}
              className="app-header__confirm"
            >
              <span>Se déconnecter</span>
              <i className="pi pi-power-off"></i>
            </div>
          )}
        </div>
      </div>
    </header>
  );

  const toast = useRef(null);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <PrimeReactProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
          <ToastContainer />
          <Toast ref={toast} />
          <CssBaseline />

          {/* Modal de déconnexion */}
          <Modal
            open={deconnect}
            disableBackdropClick={true}
            aria-describedby="modal-modal-description"
          >
            <Logout onClose={() => setdeconnect(false)} />
          </Modal>

          {/* Barre de navigation horizontale */}
          {drawer}

          {/* Drawer pour mobile */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "#111111",
                border: "none",
              },
            }}
          >
            {drawerMobile}
          </Drawer>

          {/* Contenu principal */}
          <Box component="main" className="app-content">
            <Routes>
              <Route path="/" element={<Navigate to="/LeadsList" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/LeadsList" element={<LeadsList />} />
              <Route path="/historiqueMailSuivi" element={<HistoriqueMailSuivi />} />
              {isMobilePortrait ? null : (
                <>
                  <Route path="/stockage" element={<Stockage />} />
                  <Route path="/stockageRetard" element={<StockageRetard />} />
                  <Route path="/client" element={<Client />} />
                </>
              )}
            </Routes>
          </Box>

          {/* Routes mobiles supplémentaires */}
          {isMobilePortrait && (
            <>
              <Box
                className="flex-1 w-full p-3"
                sx={{
                  ml: `-${drawerWidth}px`,
                }}
              >
                <Routes>
                  <Route path="/stockage" element={<Stockage />} />
                </Routes>
              </Box>
              <Box
                className="flex-1 w-full p-3"
                sx={{
                  ml: "-95px",
                }}
              >
                <Routes>
                  <Route path="/stockageRetard" element={<StockageRetard />} />
                </Routes>
              </Box>
              <Box
                className="flex-1 w-full p-3"
                style={{ width: "90vw" }}
              >
                <Routes>
                  <Route path="/client" element={<Client />} />
                </Routes>
              </Box>
            </>
          )}
        </Box>
      </LocalizationProvider>
    </PrimeReactProvider>
  );
}

App.propTypes = {
  window: PropTypes.func,
};

export default App;